import React from "react";
import "../assets/css/ImpactSection.css";
import indrajeet from "../assets/imgs/ip-sir.png";


import gurukul from '../assets/logos/gurukul.png';
import am from '../assets/logos/am.png';
import gm from '../assets/logos/gm.png';

import { Link } from "react-router-dom";



const ImpactSection = () => {
    return (
        <section className="impact-section">

            <div className="impact-container">

                {/* LEFT SIDE */}

                <div className="impact-left">

                    <h2>
                        Transform <br />
                        The Way <br />
                        You Think.
                    </h2>

                    <div className="yellow-line"></div>

                    <p>
                        Indrajeet Patil is a Motivational Speaker, Business
                        Psychologist and Educational Counsellor with over
                        13 years of experience helping entrepreneurs,
                        real estate professionals and business owners
                        transform their mindset, communication and
                        decision making abilities.
                    </p>

                    <Link to="/about"><button className="about-btn">
                        ABOUT INDRAJEET →
                    </button></Link>

                </div>


                {/* CENTER IMAGE */}

                <div className="impact-center">

                    <img src={indrajeet} alt="Indrajeet Patil" />

                    <div className="book-tag">
                        Invite Indrajeet
                    </div>

                </div>


                {/* RIGHT SIDE */}

                <div className="impact-right">

                    <h3>Founder of:</h3>

                    <div className="yellow-small"></div>

                    <ul>

                        <li><img src={gurukul}></img></li>

                        <li>Samriddhi Realtors</li>

                        <li><img src={gm}></img></li>

                        <li><img src={am}></img></li>

                        <li>Krishna Fleet</li>

                        <li>INS Group of Companies</li>

                    </ul>

                </div>

            </div>


            {/* STATS */}

            <div className="impact-stats">

                <div className="stat">
                    <h2>13+</h2>
                    <p>Years Experience</p>
                </div>

                <div className="stat">
                    <h2>1000+</h2>
                    <p>Participants Trained</p>
                </div>

                <div className="stat">
                    <h2>100+</h2>
                    <p>Seminars Conducted</p>
                </div>

                <div className="stat">
                    <h2>6+</h2>
                    <p>Organizations Founded</p>
                </div>

            </div>

        </section>
    );
};

export default ImpactSection;